import {
  Typography,
  Box,
  Button,
  Paper,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import { useStyles } from "./datatablecard-styles";
import {} from "@mui/material";
import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import EuroIcon from "@mui/icons-material/Euro";

const DUMMY_LIST = Array.from(Array(10).keys());



const DataTableListItem = (props) => {
  const classes = useStyles();

  return (
    <ListItem className={classes.dataTableItem}>
      <EuroIcon />
      <ListItemText
        primary={props.dataListItemText.headerText} 
        secondary={
          <React.Fragment>
            <Typography
              sx={{ display: "inline" }}
              component="span"
              variant="body2"
              color="text.main"
            >
              {props.dataListItemText.subtitle}
            </Typography>
          </React.Fragment>
        }
      />

      <Button variant="text">Edit</Button>

      <Button onClick={() => props.onDummyListChange(props)} variant="text">
        {" "}
        Delete
      </Button>

      <Typography>{/* {props.index} */}</Typography>
    </ListItem>
  );
};

export const DataTableCard = () => {
  const classes = useStyles();
  const [dummyList, setDummyList] = React.useState(DUMMY_LIST);
  const dataListItemText = {
    headerText: "Google project Apply Review",
    subtitle: "Complete in 2 Hours",
  };

  const onDummyListChange = (indexOfListItem, event) => {
    console.log("indexListItem");
    console.log(indexOfListItem);
    console.log("event");
    console.log(event);

    setDummyList((prevDummylist) => {
      const index = prevDummylist.indexOf(indexOfListItem);

      // if (index > -1) {
      //   prevDummylist.splice(indexOfListItem, 1);

      // }

      return prevDummylist;
    });
    console.log("list return");
    console.log(dummyList);
  };

  return (
    <>
      <Paper className={classes.paper} variant="elevation" elevation={0}>
        <Box className={classes.cardContentsWrapper}>
          <Box className={classes.cardTextArea}>
            <Typography variant="h6" className={classes.cardHeader}>
              Latest Activity
            </Typography>

            <Box sx={{ display: "flex" }}>
              <Typography className={classes.cardText1}>Today</Typography>
              <Divider orientation="vertical" variant="middle" flexItem />

              <Typography className={classes.cardText2}>Month</Typography>
            </Box>
          </Box>

          <Box sx={{ display: "flex" }}>
            <List className={classes.dataTableList}>
              {dummyList.map((index) => (
                <DataTableListItem
                  key={index} 
                  index={index} 
                  onDummyListChange={onDummyListChange} 
                  dataListItemText={dataListItemText}
                />
              ))}
            </List>
          </Box>
        </Box>
      </Paper>
    </>
  );
};
